import React, { useEffect, useState } from 'react';
import { PTErrors, PTInputText } from '../../components/PTElements';
import { notificationChoreType, scheduleTypes } from '../../constants';
import { Question } from './Question';
import { EVO } from '../../EVO';
import { FiftyFiftyElement } from '../../components/FiftyFiftyElement';
import { Field, useFormikContext } from 'formik';

export const NcdStep1 = props => {
    const { values, setFieldValue } = useFormikContext();
    const [whenOneOffDateTime, setWhenOneOffDateTime] = useState(values.whenOneOffDateTime || '');
    const [oneOffFrom, setOneOffFrom] = useState(values.oneOffFrom || '');
    const [oneOffTo, setOneOffTo] = useState(values.oneOffTo || '');


    useEffect(() => {
        if (values.scheduleTypeId === scheduleTypes.OneOff.value) {
            setFieldValue('whenOneOffDateTime', whenOneOffDateTime ? whenOneOffDateTime : EVO.format(new Date(), "yyyy-MM-dd'T'HH:mm"));
            setFieldValue('oneOffFrom', oneOffFrom ? oneOffFrom : EVO.format(new Date(), "yyyy-MM-dd'T'00:01"));
            setFieldValue('oneOffTo', oneOffTo ? oneOffTo : EVO.format(new Date(), "yyyy-MM-dd'T'23:59"));
        }
        else if (values.scheduleTypeId === scheduleTypes.Recurring.value) {
            setWhenOneOffDateTime(values.whenOneOffDateTime);
            setOneOffFrom(values.oneOffFrom);
            setOneOffTo(values.oneOffTo);
            setFieldValue('whenOneOffDateTime', '');
            setFieldValue('oneOffFrom', '');
            setFieldValue('oneOffTo', '');
        }
    }, [values.scheduleTypeId]);

    return (
        <div>
            {values.notificationType === notificationChoreType.Sms ? <Question>Name this message?</Question> : <Question>Name this email trigger</Question>}
            <Field name="name" type="text" component={PTInputText} placeholder="e.g 7 day Chiropractic Recall" center='true' />
            <PTErrors fields={['name']} />
            {!values.id && <div>
                <Question>What type?</Question>
                <Field name="scheduleTypeId" component={FiftyFiftyElement} options={EVO.getSelectItemFromObjectOfSelectItems(scheduleTypes)}
                    placeholder="Schedule Type" center='true' />
                <PTErrors fields={['scheduleTypeId']} />
            </div>}
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/pages/NotificationChore/NcdStep1.js